// extracted by mini-css-extract-plugin
export default {"validate-properties":"ValidatePropertiesTable_validate-properties__JjPXp","noWrap":"ValidatePropertiesTable_noWrap__7UJib"};